import { setTransferIcon } from '../utils';

export const TransferIndicatorRenderer = ({ row }) => {
  return (
    <span style={{ display: 'flex', justifyContent: 'space-between' }}>
      <p>{row.facility}</p>
      {setTransferIcon(row)}
    </span>
  );
};
